import React from "react";
import Link from "../basic/link";
import Text from "../basic/text";
import Image from "../basic/image";
import SelectCountryLink from "../specific/select-country-link";
var GroupItem = function GroupItem(_ref) {
  var item = _ref.item,
    index = _ref.index,
    language = _ref.language,
    isMobile = _ref.isMobile,
    homePageLabel = _ref.homePageLabel,
    hidden = _ref.hidden;
  return /*#__PURE__*/React.createElement("li", {
    className: "footer__group__item item-type-".concat(item.type, " ").concat(item.tag === "groupHeader" ? "group__header" : "", " ").concat(hidden ? "hidden" : "")
  }, item.type === "text" && /*#__PURE__*/React.createElement(Text, {
    content: item.html.html
  }), item.type === "image" && /*#__PURE__*/React.createElement(Image, {
    src: item.image.src,
    alt: item.image.alt
  }), item.type === "link" && item.tag !== "selectCountryLink" && /*#__PURE__*/React.createElement(Link, {
    href: item.link.href,
    content: isMobile && index === 0 ? homePageLabel : item.link.content
  }), item.tag === "selectCountryLink" && /*#__PURE__*/React.createElement(SelectCountryLink, {
    href: item.link.href,
    lang: language
  }));
};
export default GroupItem;